export const createPageMetaTitle = (pageTitle?: string) =>
  [pageTitle, 'my.reMarkable'].filter(Boolean).join(' | ');
